/**
 * @file AuthPromiseScroller.tsx
 * @brief The rotating two-line promises under "One table. Many tongues."
 *
 * @details
 * Same lines and the same hold-then-scroll as the mobile welcome screen
 * (`BrandBackdrop` PromiseScroller). The headline above it stays put.
 *
 * @author DES
 * @date 30-09-2026
 */

const PROMISES = [
  ["REAL-TIME AI INTERPRETATION", "INFRASTRUCTURE."],
  ["AUDITABLE . SCALABLE .", "ON-DEMAND"],
  ["RECORD THE MEETING.", "READ THE MINUTES"],
  ["JUST TALK.", "IT KNOWS WHO SPOKE."],
  ["SAY IT ONCE.", "KEEP THE POINT."],
  ["VOICE IS SENSITIVE.", "WE TREAT IT THAT WAY."],
  ["AUDITABLE, TRACEABLE AND", "ACCOUNTABLE."],
] as const;

export function AuthPromiseScroller() {
  const frames = [...PROMISES, PROMISES[0]];

  return (
    <div
      className="auth-promise mt-4"
      aria-label={PROMISES.map((line) => line.join(" ")).join(". ")}
    >
      <div className="auth-promise__track">
        {frames.map((line, index) => (
          <div key={index} className="auth-promise__frame">
            <p className="text-sm font-semibold leading-[1.375rem] tracking-wide text-foreground">
              {line[0]}
            </p>
            <p className="text-sm font-semibold leading-[1.375rem] tracking-wide text-foreground">
              {line[1]}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
